"use client";

import { useId } from "react";
import Link from "next/link";
import { useTranslation } from "@/contexts/TranslationContext";
import LanguageSelector from "@/components/LanguageSelector";
import WelcomeSection from "@/components/WelcomeSection";
import AboutSection from "@/components/AboutSection";
import LessonsSection from "@/components/LessonsSection";
import PricingCards from "@/components/PricingCards";
import TestimonialsSection from "@/components/TestimonialsSection";
import ContactForm from "@/components/ContactForm";

export default function HomeClient() {
	const { t } = useTranslation();
	const currentYear = new Date().getFullYear();
	const welcomeId = useId();
	const aboutId = useId();
	const lessonsId = useId();
	const pricingId = useId();
	const testimonialsId = useId();
	const contactId = useId();
	return (
		<div className="min-h-screen">
			{/* Navigation */}
			<nav className="hidden md:block fixed top-0 left-0 right-0 z-50 bg-white/95 backdrop-blur-md border-b border-gray-200 shadow-sm" aria-label="Main navigation">
				<div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
					<div className="flex justify-between items-center h-16">
						{/* Logo */}
						<div className="flex-shrink-0 flex items-center space-x-4">
							<span className="text-2xl font-bold text-gray-900">
								Nastenka en Mallorca
							</span>
							<LanguageSelector />
						</div>

						{/* Navigation Links */}
						<div className="hidden md:block">
							<div className="ml-10 flex items-center space-x-4">
								<button
									type="button"
									onClick={() =>
										document
											.getElementById(welcomeId)
											?.scrollIntoView({ behavior: "smooth" })
									}
									className="text-gray-700 hover:text-blue-600 px-3 py-2 rounded-md text-sm font-medium transition-colors duration-200 cursor-pointer"
									aria-label={t("nav.welcome")}
								>
									{t("nav.welcome")}
								</button>
								<button
									type="button"
									onClick={() =>
										document
											.getElementById(aboutId)
											?.scrollIntoView({ behavior: "smooth" })
									}
									className="text-gray-700 hover:text-blue-600 px-3 py-2 rounded-md text-sm font-medium transition-colors duration-200 cursor-pointer"
									aria-label={t("nav.about")}
								>
									{t("nav.about")}
								</button>
								<button
									type="button"
									onClick={() =>
										document
											.getElementById(lessonsId)
											?.scrollIntoView({ behavior: "smooth" })
									}
									className="text-gray-700 hover:text-blue-600 px-3 py-2 rounded-md text-sm font-medium transition-colors duration-200 cursor-pointer"
									aria-label={t("nav.lessons")}
								>
									{t("nav.lessons")}
								</button>
								<button
									type="button"
									onClick={() =>
										document
											.getElementById(pricingId)
											?.scrollIntoView({ behavior: "smooth" })
									}
									className="text-gray-700 hover:text-blue-600 px-3 py-2 rounded-md text-sm font-medium transition-colors duration-200 cursor-pointer"
									aria-label={t("nav.classes")}
								>
									{t("nav.classes")}
								</button>
								<button
									type="button"
									onClick={() =>
										document
											.getElementById(testimonialsId)
											?.scrollIntoView({ behavior: "smooth" })
									}
									className="text-gray-700 hover:text-blue-600 px-3 py-2 rounded-md text-sm font-medium transition-colors duration-200 cursor-pointer"
									aria-label={t("nav.testimonials")}
								>
									{t("nav.testimonials")}
								</button>
								<button
									type="button"
									onClick={() =>
										document
											.getElementById(contactId)
											?.scrollIntoView({ behavior: "smooth" })
									}
									className="text-gray-700 hover:text-blue-600 px-3 py-2 rounded-md text-sm font-medium transition-colors duration-200 cursor-pointer"
									aria-label={t("nav.contact")}
								>
									{t("nav.contact")}
								</button>
							</div>
						</div>

						{/* Instagram - removed, moved to WelcomeSection */}
					</div>
				</div>
			</nav>

			{/* Main Content */}
			<main id="main-content" tabIndex={-1}>
				<div id={welcomeId}>
					<WelcomeSection
						pricingId={pricingId}
						aboutId={aboutId}
						lessonsId={lessonsId}
						testimonialsId={testimonialsId}
						contactId={contactId}
					/>
				</div>

				<div id={aboutId}>
					<AboutSection />
				</div>

				<div id={lessonsId}>
					<LessonsSection />
				</div>

				<div id={testimonialsId}>
					<TestimonialsSection />
				</div>

				<div id={pricingId}>
					<PricingCards contactId={contactId} />
				</div>

				<div id={contactId}>
					<ContactForm />
				</div>
			</main>

			{/* Footer */}
			<footer className="bg-black/20 backdrop-blur-md border-t border-white/20 py-8" role="contentinfo">
				<div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
					<div className="flex flex-col md:flex-row justify-between items-center">
						<div className="text-gray-700 text-sm mb-4 md:mb-0">
							{t("footer.copyright", { year: currentYear })}
						</div>

						<div className="flex gap-6">
							<Link
								href="/privacy"
								className="text-gray-600 hover:text-gray-900 transition-colors"
							>
								{t("footer.privacyPolicy")}
							</Link>
							<Link
								href="/tac"
								className="text-gray-600 hover:text-gray-900 transition-colors"
							>
								{t("footer.termsOfService")}
							</Link>
						</div>
					</div>
				</div>
			</footer>
		</div>
	);
}
